<template>
  <div>
    <!--Default preloader for full screen mode-->
    <vue-element-loading v-if="type === 'default'" :active="active" :is-full-screen="true"> </vue-element-loading>

    <!--Preloader that will be used with containers (e.g. buttons, iframes)-->
    <vue-element-loading
      v-if="type === 'container'"
      :color="themeStyles.primaryColor.color"
      :active="active"
      :is-full-screen="false"
      spinner="mini-spinner"
    ></vue-element-loading>
  </div>
</template>

<script>
/**
 * Digital Event Preloader
 * Wrapper for "VueElementLoading" component
 * All custom properties we can send via "options" property
 */
import VueElementLoading from "vue-element-loading";

export default {
  name: "Preloader",
  components: {
    VueElementLoading
  },
  props: {
    type: {
      type: String,
      default: "default"
    },
    active: {
      type: Boolean,
      default: false
    },
    isFullScreen: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    themeStyles() {
      return this.$store.state.themeStyles;
    }
  }
};
</script>
